<ng-container [formGroup]="form">
  <div class="row">
    <div class="col">
      <mat-form-field appearance="fill" [class]="class">
        <mat-label>{{ label }}</mat-label>
        @if (restrictDollarDecimalPoint) {
          <input
            [attr.data-cy]="datacy"
            [attr.name]="controlName"
            maxlength="200"
            matInput
            [errorStateMatcher]="errorState"
            [placeholder]="placeholder"
            [id]="id"
            [formControlName]="controlName"
            [required]="required"
            [type]="type"
            [value]="value"
            appRestrictDollarDecimalPoint
            (numericValue)="form.get(controlName).setValue($event)"
          />
        }

        @if (restrictPercentDecimalPoint) {
          <input
            [attr.data-cy]="datacy"
            [attr.name]="controlName"
            maxlength="200"
            matInput
            [errorStateMatcher]="errorState"
            [placeholder]="placeholder"
            [id]="id"
            [formControlName]="controlName"
            [required]="required"
            [type]="type"
            [value]="value"
            appRestrictPercentDecimalPoint
            (numericValue)="form.get(controlName).setValue($event)"
          />
        }
        @if (!restrictPercentDecimalPoint && !restrictDollarDecimalPoint) {
          <input [attr.data-cy]="datacy" [attr.name]="controlName" maxlength="200" matInput [errorStateMatcher]="errorState" [placeholder]="placeholder" [id]="id" [formControlName]="controlName" [required]="required" [type]="type" [value]="value" />
        }
        @if (form.get(controlName).hasError('required') && form.get(controlName).touched) {
          <mat-error attr.data-cy="{{ datacy }}-required-error">
            <i attr.data-cy="{{ datacy }}_error" class="icon-warning_white" aria-hidden="true"></i>
            {{ label }} is required
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</ng-container>
